import Vue from 'vue';
import CUtils from '../utils/c.utils-0.1.0';

/**
 * 格式化日期 yyyy-MM-dd HH:mm:ss
 */
Vue.filter('date', function (value) {
  if (!value) {
    return '';
  } else {
    return CUtils.formatDateTime(value);
  }
});
Vue.filter('new-date', function (value) {
  if (!value) {
    return '';
  } else {
    var date = new Date(value);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? '0' + d : d;
    var h = date.getHours();
    h = h < 10 ? '0' + h : h;
    var minute = date.getMinutes();
    minute = minute < 10 ? '0' + minute : minute;
    return y + '.' + m + '.' + d + ' ' + h + ':' + minute;
  }
});
Vue.filter('newDateNoHours', function (value) {
  if (!value) {
    return '';
  } else {
    var date = new Date(value);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? '0' + d : d;
    return y + '.' + m + '.' + d;
  }
});
Vue.filter('new-date-noYears', function (value) {
  if (!value) {
    return '';
  } else {
    var date = new Date(value);
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? '0' + d : d;
    var h = date.getHours();
    h = h < 10 ? '0' + h : h;
    var minute = date.getMinutes();
    minute = minute < 10 ? '0' + minute : minute;
    return m + '月' + d + '日' + h + ':' + minute;
  }
});